import { dataInputsFeatures, dataInputsLanguages } from './content';

import Languages from './languages';
import AnnotationTypes from './annotation-types';

const DataInputs = ({ dataLanguages, annotationType }) => (
  <div>
    <AnnotationTypes dataInputsFeatures={dataInputsFeatures} annotationType={annotationType} />
    {dataLanguages && <Languages dataInputsLanguages={dataInputsLanguages} />}
  </div>
);

export default DataInputs;
